
<div id="banner">
    {#if dev == 'true'}
        <div class="buttons hidden">
            <button id="login-button-fred-dummy" class="select-button">Login fred</button>
            <button id="login-button-jeff-dummy" class="select-button">Login jeff</button>
            <button class="select-button" id="login-dummy"></button>
            <span id="login-as-text-dummy"></span>
        </div>
    {/if}

    <span class="left">&nbsp</span>
    <div class="center h2">BBO Chat</div>
    <div class="buttons">
        <span id="login-as-text" class="right"></span>
        {#if dev == 'true'}
            <button id = "login-test-button" class="select-button right"
                on:click={assignTempUserIdJeff}>Login jeff</button>
            <button id = "login-test-button" class="select-button right"
                on:click={assignTempUserIdFred}>Login fred</button>
        {/if}
        <button class="select-button right" data-netlify-identity-button id="login"></button>
    </div>
</div>

<style>

    #banner {
        display: flex;
        padding-bottom: 1vh;
        padding-right: 3vw;
    }

    .h2 {
        text-align: center;
        font-size: 2.5vh;
    }

    .left {
        width: 14vh;
        float:left;
    }

    .center {
        margin: 0px auto;
    }

    #login-as-text {
        visibility: hidden;
        margin: 0.75vh 0.25vw;
        font-size: 1.5vh;
        color: #888;
    }

    .right {
        float:right;
    }

    #login {
        text-align: center;
        width: 10vh;
        height:  4vh;
        font-size: 1.4vh;
        border-style: solid;
        border-radius: 1vh;
        border-width: 0.25vh;
    }

    .buttons {
        display: flex;
        gap: 0.25vw;
    }

    .hidden {
        visibility: hidden;
    }
</style>

<script>
    import { setupUser, logoutUser } from './user.js';

    let dev = process.env.DEV_MODE;
    console.log(dev);


    function assignTempUserIdJeff() {
        let login_id = '624f09e0-834a-4a12-8bef-06d257eeb93c';  // jeff
        setupUser(login_id)
    }

    function assignTempUserIdFred() {
        let login_id = '123621b8-d6fc-465e-90ae-dca8d83e3321x';  // fred
        setupUser(login_id)
    }

    function logout() {
        logoutUser()
    };
</script>